import { Container, Row, Col, Breadcrumb, Tab, Nav } from "react-bootstrap";
import { Link } from "react-router-dom";
import BillingHistory from "./BillingHistory";
import BillingAddress from "./BillingAddress";
import { useSubscriptionContext } from "context/subscriptionContext";
import CurrentPlanInformation, {
    SubscriptionPlanType,
    getSubscriptionPlanType,
} from "components/subscriptions/CurrentPlanInformation";
import withSubscriptionPermissionCheck from "components/hoc/SubscriptionPermissionCheck";
import AddOnInformation from "components/subscriptions/AddOnInformation";
import BraintreeInformation from "components/subscriptions/BraintreeInformation";
import { useEffect } from "react";
import { getLatestSubscription } from "service/subscriptionService";
import { isEmpty } from "lodash";

const ManageSubscription = () => {
    const {
        subscription,
        subscription: {
            customer: { is_prepaid = false, is_cancellable = true } = {},
            address,
        },
        setSubscription,
    }: any = useSubscriptionContext();
    const subscriptionType = getSubscriptionPlanType({
        is_prepaid,
        is_cancellable,
    });

    // ========================= USEEFFECT =========================

    useEffect(() => {
        const fetchLatestSubscription = async () => {
            const latestSubscription = await getLatestSubscription();
            setSubscription(latestSubscription);
        };
        if (isEmpty(subscription)) {
            fetchLatestSubscription();
        }
    }, [subscription, setSubscription]);

    return (
        <div className="page-content subscription-page">
            <Container fluid>
                <Row>
                    <Col>
                        <h5 className="page-title" aria-label="page-title">
                            Manage Subscription
                        </h5>
                    </Col>
                </Row>
                <Row>
                    <Col sm="12">
                        <Breadcrumb className="w-100">
                            <Breadcrumb.Item
                                linkAs={Link}
                                linkProps={{
                                    to: "/manage-subscription",
                                    "aria-label": "subscription-breadcrumb",
                                }}
                            >
                                Subscription
                            </Breadcrumb.Item>
                            <Breadcrumb.Item active>
                                Manage Subscription
                            </Breadcrumb.Item>
                        </Breadcrumb>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <div className="page-tabs">
                            <Tab.Container
                                id="left-tabs-example"
                                defaultActiveKey="payment-info"
                            >
                                <Row>
                                    <Col sm={12}>
                                        <Nav>
                                            <Nav.Item>
                                                <Nav.Link eventKey="payment-info">
                                                    <h6>Manage</h6>
                                                </Nav.Link>
                                            </Nav.Item>
                                            {subscriptionType !==
                                                SubscriptionPlanType.BASIC && (
                                                <>
                                                    {" "}
                                                    <Nav.Item>
                                                        <Nav.Link eventKey="billing-history">
                                                            <h6>
                                                                Billing History
                                                            </h6>
                                                        </Nav.Link>
                                                    </Nav.Item>
                                                    {address && (
                                                        <Nav.Item>
                                                            <Nav.Link eventKey="billing-address">
                                                                <h6>
                                                                    Billing
                                                                    Address
                                                                </h6>
                                                            </Nav.Link>
                                                        </Nav.Item>
                                                    )}
                                                </>
                                            )}
                                        </Nav>
                                    </Col>
                                    <Col sm={12}>
                                        <Tab.Content>
                                            <Tab.Pane eventKey="payment-info">
                                                <CurrentPlanInformation />
                                                <AddOnInformation />
                                                <BraintreeInformation />
                                            </Tab.Pane>
                                            <Tab.Pane eventKey="billing-history">
                                                <BillingHistory />
                                            </Tab.Pane>
                                            <Tab.Pane eventKey="billing-address">
                                                <BillingAddress />
                                            </Tab.Pane>
                                        </Tab.Content>
                                    </Col>
                                </Row>
                            </Tab.Container>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default withSubscriptionPermissionCheck(ManageSubscription);
